import {Component, input, InputSignal, output} from '@angular/core';

import {SvgSpriteIcon} from '../svg-sprite';
import {Breadcrumb} from './breadcrumb.model';

@Component({
  selector: 'lib-breadcrumbs',
  standalone: true,
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent<T extends Breadcrumb> {
  protected readonly SvgSpriteIcon = SvgSpriteIcon;

  readonly buttons: InputSignal<T[]> = input.required();

  clicked = output<T>();

  onClick(button: T): void {
    if (button.closeable) {
      this.clicked.emit(button);
    }
  }
}
